/** Laravel API base — used for login / register / account / catalog / cart */

import { getAuthHeaders, getCartToken, storeCartToken } from './cartToken';

const envApiUrl = process.env.REACT_APP_API_URL?.trim();

function getFallbackApiUrl() {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname.toLowerCase();
    if (host === 'localhost' || host === '127.0.0.1') {
      return 'http://localhost:8000/api';
    }
  }

  return process.env.NODE_ENV === 'development'
    ? 'http://localhost:8000/api'
    : 'https://api.ammachekku.com/api';
}

export const API_URL = (envApiUrl || getFallbackApiUrl()).replace(/\/+$/, '');

async function parseJsonResponse(response) {
  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (data?.cart_token) {
    storeCartToken(data.cart_token);
  }

  if (!response.ok) {
    const message =
      data?.message ||
      (data?.errors && Object.values(data.errors).flat().join(' ')) ||
      `Request failed (${response.status})`;
    const error = new Error(message);
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}

export async function apiGet(path, { auth = false } = {}) {
  const headers = auth
    ? getAuthHeaders()
    : { Accept: 'application/json' };

  const response = await fetch(`${API_URL}${path.startsWith('/') ? path : `/${path}`}`, {
    method: 'GET',
    headers,
  });

  return parseJsonResponse(response);
}

export async function apiPost(path, body, { auth = false } = {}) {
  const headers = auth
    ? { ...getAuthHeaders(), 'Content-Type': 'application/json' }
    : {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      };

  const payload =
    auth && body && typeof body === 'object'
      ? { ...body, cart_token: body.cart_token || getCartToken() }
      : body;

  const response = await fetch(`${API_URL}${path.startsWith('/') ? path : `/${path}`}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });

  return parseJsonResponse(response);
}

export default API_URL;
